import { Checkbox, Label, Description, Input, CheckboxChildren } from './styles'

Checkbox.Label = Label
Checkbox.Description = Description
Checkbox.Input = Input
Checkbox.Children = CheckboxChildren

export default Checkbox
